import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';

declare var $:any;

@Component({
  selector: 'chamada-modulo',
  templateUrl: './chamada-modulo.component.html',
  styleUrls: ['./chamada-modulo.component.scss']
})
export class ChamadaModuloComponent implements OnInit,AfterViewInit {

  @Input("data") data:any         = null;   
  @Input("template") template:any = null;
  @ViewChild("slider") slider:any = null;

  constructor(){}
  
  /**
   * 
   * Init
   * 
   */
  initSlider(){

    $(this.slider.nativeElement).slick({  
      infinite: true,
      slidesToShow: 5,
      dots: false,
      arrows: false, 
      autoplay: true,
      centerMode: false,
      centerPadding: '5px', 
      responsive: [{
          breakpoint: 1224,
          settings: {
              slidesToShow: 5, 
          }
      },{
          breakpoint: 1024,
          settings: {
          slidesToShow: 4,
        }
      },
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 3,

          }
      },
      {
          breakpoint: 540,
          settings: {
            slidesToShow: 1,
            centerPadding: '0',
          }
      }
    ]
    
    }); 
    $(this.slider.nativeElement).slick('refresh');  

  }
  /**
   * 
   * Next
   * 
   */
   prev(){ 

    $(this.slider.nativeElement).slick("slickPrev");  

  }
  /**
   * 
   * Next
   * 
   */
  next(){

    $(this.slider.nativeElement).slick("slickNext"); 

  }
  /***
   * 
   * Init
   * 
   **/
  ngOnInit():void{}
  /**
   * 
   * After init
   * 
   */
  ngAfterViewInit(): void {
    this.initSlider();
  }

}
